import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20sunlit%20retail%20boutique%20interior%20with%20neatly%20displayed%20fashion%20items%20on%20wooden%20shelves%2C%20soft%20golden%20hour%20light%20streaming%20through%20large%20window%2C%20lifestyle%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20organic%20composition%20with%20clothing%20shoes%20and%20accessories%2C%20editorial%20quality%2C%20warm%20neutral%20tones&width=1800&height=1200&seq=hero-bg-v2&orientation=landscape"
          alt="ACBuySpreadsheet product categories showcase"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/35"></div>
      </div>

      <div className="relative z-10 flex-1 flex flex-col items-center justify-center w-full px-4 md:px-6 pt-16 pb-20">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white text-center leading-tight max-w-4xl drop-shadow-sm">
          ACBuySpreadsheet
          <br />
          <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-normal italic opacity-90">
            The Ultimate Tracking System
          </span>
        </h1>

        <p className="mt-6 text-sm md:text-base text-white/85 text-center max-w-2xl leading-relaxed">
          Streamline your ACBuy operations with powerful spreadsheet tools designed for tracking orders, calculating profit, and scaling your workflow efficiently.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-white rounded-md text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            ACBuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-md text-sm md:text-base font-semibold hover:bg-white/25 transition-colors whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-white/60 text-xs md:text-sm">
          <span className="flex items-center gap-1.5">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line"></i>
            </span>
            Updated Spreadsheet System
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line"></i>
            </span>
            Beginner-Friendly Setup
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line"></i>
            </span>
            Automated Profit Tracking
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line"></i>
            </span>
            Secure Data Structure
          </span>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
          <a
            href="#categories"
            className="w-10 h-10 flex items-center justify-center text-white/60 hover:text-white transition-colors"
          >
            <i className="ri-arrow-down-s-line text-2xl animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
}